import React from 'react';
import { PropertyTypeTabList } from './PropertyTypeTabs.style';
import commonResource from '../../locales/th/common.json';
import { PropertyTypeTabItem } from './PropertyTypeTabItem';
import condoImage from '../../common/assets/condo.jpg';
import houseImage from '../../common/assets/house.jpg';
import townhomeImage from '../../common/assets/townhome.jpg';

const propertyTypeTabs = commonResource.propertyTypeTabs.tabs;
const propertyTypeTabList = [
  {
    label: propertyTypeTabs.condo,
    name: 'Condo',
    url: '/คอนโด/',
    image: condoImage,
  },
  {
    label: propertyTypeTabs.house,
    name: 'House',
    url: '/บ้าน/',
    image: houseImage,
  },
  {
    label: propertyTypeTabs.townhome,
    name: 'Townhome',
    url: '/ทาวน์โฮม/',
    image: townhomeImage,
  },
];

interface PropertyTypeTabsProps {
  onClickTabCard?: (tab: string) => void;
}

export const PropertyTypeTabs: React.FC<PropertyTypeTabsProps> = ({
  onClickTabCard,
}) => {
  return (
    <PropertyTypeTabList>
      {propertyTypeTabList.map((tab) => {
        return (
          <PropertyTypeTabItem
            key={tab.url}
            tab={tab}
            onClickTabCard={() => onClickTabCard(tab.name)}
          />
        );
      })}
    </PropertyTypeTabList>
  );
};
